import EmptyCatalog from './EmptyCatalog.vue';

export { EmptyCatalog };
export default EmptyCatalog;
